module.exports = __webpack_public_path__ + "./docs/img/big-icon-function.15e2ce831fabbad27ebf0520ea4c0d22.svg";